import React from "react";

export const CardComponent2 = (props) => {
  return <>{props.children}</>;
};

const SummaryCard = (props) => {
  return (
    <>
      <div className="container-margin-summary">
        <div className="new-investor-summary-card-header">{props.title}</div>
        <div className="new-investor-summary-card">{props.children}</div>
      </div>
    </>
  );
};

export default CardComponent2;
export { SummaryCard };
